export enum SalesOverviewReportTableAccessor {
  CustomerName = 'customerName',
  GrossTotal = 'grossTotal',
  InvoiceNumber = 'invoiceNumber',
  IssueDate = 'issueDate',
  NetTotal = 'netTotal',
  PaymentDate = 'paidDate',
  TaxTotal = 'taxTotal',
}
